import { defineTranslateKeys } from 'lib/tolgee'

const TOLGEE_KEYS = defineTranslateKeys({
  contextNameDescription: {
    key: 'emptyNiches-contextNameDescription',
    defaultValue: 'Este assunto não tem vídeos o suficiente para fazermos nossas análises.',
  },

  contextNameSuggestion: {
    key: 'emptyNiches-contextNameSuggestion',
    defaultValue: 'Verifique erros de digitação e tente outros termos para melhores resultados.',
  },

  contextName: ({ contextName }: { contextName: string }) => ({
    key: 'emptyNiches-contextName',
    parameters: {
      contextName,
      strong: <strong></strong>,
    },
    defaultValue: 'Não encontramos nichos relevantes sobre <strong>{contextName}</strong> por enquanto.',
  }),
})

export default TOLGEE_KEYS
